import { render, staticRenderFns } from "./AnswerSecurity.vue?vue&type=template&id=36c685a2&"
import script from "./AnswerSecurity.vue?vue&type=script&lang=js&"
export * from "./AnswerSecurity.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSecurity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports